import * as auth from 'services/auth';

const BASE_URL = `${import.meta.env.VITE_URL_API}/api/v1/affiliate`;

export const apiFetch = async (path: string, options: RequestInit):Promise<Response> => fetch(
  `${BASE_URL}${path}`,
  {
    ...options,
    headers: {
      'Content-Type': 'application/json',
      'x-res-api-key': auth.getToken(),
    },
  },
);
